module.exports = __webpack_public_path__ + "static/media/abhinav_roy.4a449944.jpeg";